module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "klickbox-edit-item": "general",
      "klickbox-edit-label": _vm.$t('edit.canvas.general_styles')
    }
  }, [(_vm.boxConfig.progressbar.kind !== 'counter') ? _c('progress-bar') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kbx-content"
  }, [(_vm.boxConfig.progressbar.kind === 'counter') ? _c('counter') : _vm._e(), _vm._v(" "), _c('title-preview'), _vm._v(" "), _c('description'), _vm._v(" "), _c('form-email')], 1)], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-6495b91f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/email/Main.vue
 ** module id = 848
 ** module chunks = 1
 **/